import { getOperationNotificationConnectionId } from "components/notifications/store/api";
const BYTES_IN_KILOBYTE = 1024;
const CHUNK_SIZE = 4 * BYTES_IN_KILOBYTE * BYTES_IN_KILOBYTE;
export const readChunkAsBase64 = (blob) => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
        const result = reader.result;
        resolve(result.split(",")[1]);
    };
    reader.onerror = reject;
    reader.readAsDataURL(blob);
});
export const fileToBase64 = (file) => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
        const result = reader.result;
        const [, base64] = result.split(",");
        resolve(base64);
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);
});
const createUploadHeaders = () => ({ "Connection-Id": getOperationNotificationConnectionId() });
const cancelUpload = async (uploadId, headers, baseQuery) => {
    await baseQuery({
        body: { uploadId },
        headers,
        method: "POST",
        url: "/documents/upload/cancel"
    });
};
const uploadChunks = async (file, totalChunks, uploadId, headers, baseQuery) => {
    for (let index = 0; index < totalChunks; index += 1) {
        /* eslint-disable no-await-in-loop */
        const start = index * CHUNK_SIZE;
        const end = Math.min(start + CHUNK_SIZE, file.size);
        const chunkData = await readChunkAsBase64(file.slice(start, end));
        const chunkResult = await baseQuery({
            body: { chunkData, chunkIndex: index, uploadId },
            headers,
            method: "POST",
            url: "/documents/upload/chunk"
        });
        if (chunkResult.error) {
            await cancelUpload(uploadId, headers, baseQuery);
            return { error: chunkResult.error };
        }
    }
    return undefined;
};
const finalizeUpload = async (uploadId, headers, baseQuery) => {
    const finalizeResult = await baseQuery({
        body: { uploadId },
        headers,
        method: "POST",
        url: "/documents/upload/finalize"
    });
    if (finalizeResult.error) {
        return { error: finalizeResult.error };
    }
    return { data: finalizeResult.data };
};
export const executeUploadDocument = async (request, baseQuery, api) => {
    const { documentId, file, noteId } = request;
    const totalChunks = Math.ceil(file.size / CHUNK_SIZE);
    const headers = createUploadHeaders();
    const initiateResult = await baseQuery({
        body: { fileName: file.name, noteId, totalChunks, totalSize: file.size },
        headers,
        method: "POST",
        url: "/documents/upload/initiate"
    });
    if (initiateResult.error) {
        return { error: initiateResult.error };
    }
    const { uploadId } = initiateResult.data;
    const { setDocumentUploadId } = await import("../index");
    api.dispatch(setDocumentUploadId({ documentId, uploadId }));
    const chunkUploadError = await uploadChunks(file, totalChunks, uploadId, headers, baseQuery);
    if (chunkUploadError) {
        return chunkUploadError;
    }
    return finalizeUpload(uploadId, headers, baseQuery);
};
export const buildDocumentEndpoints = (builder) => ({
    deleteDocument: builder.mutation({
        invalidatesTags: ["Notes"],
        query: (request) => ({
            method: "DELETE",
            url: `/documents/${request.documentId}`
        })
    }),
    uploadDocument: builder.mutation({
        invalidatesTags: ["Notes"],
        queryFn: (request, api, _extraOptions, baseQuery) => executeUploadDocument(request, baseQuery, api)
    })
});
